import type { RouteObject } from 'react-router-dom';

export const profileRoutes: RouteObject[] = [
  { path: 'profil', lazy: () => import('./ProfilePage').then((m) => ({ Component: m.ProfilePage })) },
  { path: 'notifications', lazy: () => import('./NotificationsPage').then((m) => ({ Component: m.NotificationsPage })) },
];
